export const formFields = [
  {
    id: "email",
    name: "email",
    label: "Email",
    validated: true,
    type: "email",
    placeholder: "Enter your Email",
    errormsg: "Email is required",
  },
  {
    id: "password",
    name: "password",
    label: "Password",
    validated: true,
    type: "password",
    placeholder: "Enter your Password",
    errormsg: "Password is required",
  },
];

export const initialValues = {
  email: "",
  password: "",
};
